export default __webpack_public_path__ + "static/media/50958300.487dccb1.jpg";